export enum SnapshotGroupBy {
    BOOKING = 'booking',
    DAY = 'day',
    WEEK = 'week',
    HOUR = 'hour',
}

export interface SnapshotEventTime {
    time?: number;
    date?: string;
    timestamp?: string;
}

export interface SnapshotWaitingTime {
    time?: number;
    from?: string;
    to?: string;
    fromTimestamp?: string;
    toTimestamp?: string;
}

export interface SnapshotItem {
    _id: string;
    bookingID: string;
    bookingNumericID: number;
    createdAt: string;
    accepted?: SnapshotEventTime;
    arrivedAtPickup?: SnapshotEventTime;
    completed?: SnapshotEventTime;
    waitingTime?: SnapshotWaitingTime;
}

export interface StatsItem {
    average: number;
    min: number;
    max: number;
}

export interface SnapshotItemGrouped {
    period: string;
    periodLabel: string;
    bookingCount: number;
    averages: {
        ACCEPTED: StatsItem;
        ARRIVED_AT_PICKUP: StatsItem;
        COMPLETED: StatsItem;
        WAITING_TIME: StatsItem;
    };
    min: {
        ACCEPTED: StatsItem;
        ARRIVED_AT_PICKUP: StatsItem;
        COMPLETED: StatsItem;
        WAITING_TIME: StatsItem;
    };
    max: {
        ACCEPTED: StatsItem;
        ARRIVED_AT_PICKUP: StatsItem;
        COMPLETED: StatsItem;
        WAITING_TIME: StatsItem;
    };
}

export interface SnapshotStatsData {
    ACCEPTED: StatsItem;
    ARRIVED_AT_PICKUP: StatsItem;
    COMPLETED: StatsItem;
    WAITING_TIME: StatsItem;
}

export interface SnapshotsResponseData {
    snapshots: SnapshotItem[] | SnapshotItemGrouped[];
    total: number;
    stats: SnapshotStatsData;
}
export interface ChartPoint {
    date: string;
    acceptedMin: number;
    arrivedMin: number;
    completedMin: number;
    waitingTimeMin: number;
    bookingNumericID: number | string;
    bookingID?: string;
}
